import { render, staticRenderFns } from "./LabelWithCount.vue?vue&type=template&id=22c0dc2c&scoped=true&"
import script from "./LabelWithCount.vue?vue&type=script&lang=js&"
export * from "./LabelWithCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0dc2c",
  null
  
)

export default component.exports